import moment from 'moment'
import classnames from 'classnames'
import { useDispatch, useSelector } from 'react-redux'
import _ from 'lodash'
import { useEffect, useMemo, useState } from 'react'
import { DATETIME_FORMAT, getMomentInCommunityTimezone } from '../../../utility/datesHelper'
import { getCommunityCategories } from '../../../actions/programCategoryActions'
import { getProgramsFilterOptions } from '../../../actions/programActions'
import LeaderboardWrapper from '../../common/leaderboard/LeaderboardWrapper'
import FiltersButtonDropdown, { FIXED_DATE_RANGES_FUNCTIONS } from './FiltersButtonDropdown'

import styles from './CoachDashboardOp36.module.scss'

const DEFAULT_FILTERS = {
  ...FIXED_DATE_RANGES_FUNCTIONS['30days'].valueFunc(),
  categoryOption: null,
  programOption: null,
}

const CoachDashboardCommunityLeaderboard = () => {
  const dispatch = useDispatch()
  const community = useSelector(state => state.user.current_user.communities[0])

  const [filters, setFilters] = useState(DEFAULT_FILTERS)

  const requestFilters = useMemo(() => ({
    startDate: getMomentInCommunityTimezone(moment(filters.startDate), community?.timezone, DATETIME_FORMAT).toDate(),
    endDate: getMomentInCommunityTimezone(moment(filters.endDate), community?.timezone, DATETIME_FORMAT).toDate(),
    categoryId: filters.categoryOption && filters.categoryOption.value === null
      ? 'null'
      : filters.categoryOption?.value,
    programId: filters.programOption?.value,
  }), [community?.timezone, filters.categoryOption, filters.endDate, filters.programOption?.value, filters.startDate])

  const hasAppliedFilters = !_.isEqual(filters, DEFAULT_FILTERS)

  const onClearFilters = () => setFilters(DEFAULT_FILTERS)

  const onSubmitFilters = (newFilters) => {
    if (!_.isEqual(filters, newFilters)) {
      setFilters(prevState => ({ ...prevState, ...newFilters }))
    }
  }

  useEffect(() => {
    dispatch(getCommunityCategories())
    dispatch(getProgramsFilterOptions({ completed: true, active: true }))
  }, [dispatch])

  return (
    <div className={classnames('d-flex flex-column', styles.communityLeaderboard)}>
      <div className='p-3 d-flex justify-content-between align-items-center'>
        <h3 className={styles.title}>Community Leaderboard</h3>
        <FiltersButtonDropdown
          title='Leaderboard Filters'
          defaultFilters={DEFAULT_FILTERS}
          appliedFilters={filters}
          onSubmitFilters={onSubmitFilters}
        />
      </div>
      <LeaderboardWrapper
        withDetailedLeaderboard
        withClearFiltersButton={hasAppliedFilters}
        filters={requestFilters}
        onClearFiltersClick={onClearFilters}
        classNames={{
          tabs: 'flex-grow-1',
          tabList: 'mx-3',
        }}
      />
    </div>
  )
}

export default CoachDashboardCommunityLeaderboard
